export default "__VITE_ASSET__Dofea_ml__"